import { Typography } from '@veraclins-dev/ui';
import { cn } from '@veraclins-dev/utils';

import type { TypographyComponentProps } from './types';

export function EditorialLede({
  className,
  ...props
}: TypographyComponentProps) {
  return (
    <Typography
      variant="body1"
      {...props}
      // oxlint-disable-next-line veraclins-ui/prefer-style-props -- 56ch unit has no scale-token/prop equivalent
      className={cn(
        'max-w-[56ch] font-serif text-[clamp(1.125rem,1.6vw,1.375rem)] leading-normal text-muted-foreground',
        className,
      )}
    />
  );
}
